import React from "react";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { HERO_STATS } from "../mock";

function MathsCard() {
  const row = (label, price, accent, strike) => (
    <div className="flex items-baseline justify-between" style={{ padding: "13px 0", borderBottom: "1px solid var(--line)" }}>
      <span style={{ fontSize: 14.5, color: accent ? "var(--ink)" : "var(--ink-soft)", fontWeight: accent ? 600 : 400 }}>{label}</span>
      <span
        className="mono"
        style={{
          fontSize: 13.5,
          fontWeight: 600,
          color: accent ? "var(--accent)" : "var(--ink-faint)",
          textDecoration: strike ? "line-through" : "none",
          textDecorationColor: "var(--ink-faint)",
        }}
      >
        {price}
      </span>
    </div>
  );

  return (
    <div
      className="card-line"
      style={{ position: "relative", zIndex: 1, borderRadius: 10, padding: "28px 28px 24px", background: "var(--card)" }}
    >
      <div className="flex items-center justify-between" style={{ marginBottom: 18 }}>
        <span className="eyebrow">The maths</span>
        <span
          style={{ fontSize: 11.5, fontWeight: 600, color: "var(--warm-ink)", background: "rgba(188,107,60,0.12)", padding: "4px 10px", borderRadius: 99, letterSpacing: "0.02em" }}
        >
          ≈ 60% less spend
        </span>
      </div>

      <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
        <span className="serif" style={{ fontSize: 68, lineHeight: 0.9, color: "var(--warm)" }}>40%</span>
        <span style={{ fontSize: 15, lineHeight: 1.4, color: "var(--ink-soft)", maxWidth: 150 }}>
          of a Belkins&#8209;tier retainer, same booked&#8209;meeting outcome.
        </span>
      </div>

      <div style={{ marginTop: 22, borderTop: "1px solid var(--line)" }}>
        {row("Typical agency retainer", "≈ $4,500/mo", false, true)}
        {row("Conduit, all in", "from $1,750/mo", true, false)}
      </div>

      <p style={{ marginTop: 16, fontSize: 12.5, color: "var(--ink-faint)", lineHeight: 1.5 }}>
        Infrastructure, signal lists, copy and sending included. Replies land under your own name.
      </p>
    </div>
  );
}

export default function Hero() {
  return (
    <section id="top" className="dotgrid" style={{ position: "relative", paddingTop: 130, paddingBottom: 76, overflow: "hidden" }}>
      <div className="hero-glow" />
      <div className="hero-glow-2" />
      <div className="container-x" style={{ position: "relative", zIndex: 1 }}>
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-14 items-center">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="section-label" style={{ marginBottom: 26 }}>
                Outbound for market entry · UK, EU, US
              </div>
            </Reveal>

            <Reveal delay={60}>
              <h1 className="h-display">
                Belkins&#8209;grade meetings,{" "}
                <span className="serif" style={{ fontSize: "1.02em", color: "var(--accent)" }}>at 40% of the price.</span>
              </h1>
            </Reveal>

            <Reveal delay={120}>
              <p style={{ maxWidth: 560, marginTop: 26, fontSize: 18, lineHeight: 1.65, color: "var(--ink-soft)" }}>
                Cold email outbound for B2B software and service companies entering the{" "}
                <strong style={{ color: "var(--ink)", fontWeight: 600 }}>UK, Europe and the US</strong>. We build the
                infrastructure, find accounts with a reason to buy now, and put replies in your inbox under your own name.
              </p>
            </Reveal>

            <Reveal delay={180}>
              <div className="flex flex-wrap items-center gap-3" style={{ marginTop: 32 }}>
                <a href="#apply" className="btn btn-primary">
                  Apply to work with us <ArrowRight size={16} />
                </a>
                <a href="#demo" className="btn btn-ghost">See the live demo</a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={160}>
              <MathsCard />
            </Reveal>
          </div>
        </div>

        <div
          className="grid"
          style={{ marginTop: 64, gap: 0, gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", borderTop: "1px solid var(--line)" }}
        >
          {HERO_STATS.map((s, i) => (
            <Reveal key={i} delay={i * 90}>
              <div
                style={{
                  padding: "26px 26px 26px 0",
                  borderRight: i < HERO_STATS.length - 1 ? "1px solid var(--line)" : "none",
                  paddingLeft: i === 0 ? 0 : 26,
                  height: "100%",
                }}
              >
                <div className="serif" style={{ fontSize: 26, letterSpacing: 0, color: "var(--ink)" }}>{s.value}</div>
                <div style={{ marginTop: 6, fontSize: 14.5, color: "var(--ink-soft)", lineHeight: 1.5 }}>{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
